import { createContext, FC, useContext, useEffect, useState } from "react";
import { AssociationUser, User } from "../sdk";

export const ActiveAssociationUserContext = createContext<{
  associationUser: AssociationUser | undefined;
  // setAssociationUser: (associationUser: AssociationUser | null) => void;
}>({ associationUser: undefined });

interface Props {
  children: React.ReactNode;
  associationUser?: AssociationUser;
}

export const AssociationUserShowProvider: FC<Props> = ({
  children,
  associationUser,
}) => {
  return (
    <ActiveAssociationUserContext.Provider value={{ associationUser }}>
      {associationUser ? children : <>Loading</>}
    </ActiveAssociationUserContext.Provider>
  );
};

export const useAssociationUserShow = () => {
  return useContext(ActiveAssociationUserContext);
};
